export default {"src":"/_next/static/media/raven.fcc2c1f1.svg","height":49,"width":178,"blurWidth":0,"blurHeight":0};